import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuUpdateService {
  private menuUpdateSubject = new BehaviorSubject<void>(null);
  menuUpdate$ = this.menuUpdateSubject.asObservable();

  updateMenu() {
    this.menuUpdateSubject.next();
  }
}